module.exports = __webpack_public_path__ + "static/img/guide-08.67e0e295.png";